import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IUserModel } from 'src/app/core/models/masters/user-master.model';
import { GenericListView } from 'src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { GenericEntryForm } from 'src/app/infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-validations',
  templateUrl: './validations.component.html',
  styleUrls: ['./validations.component.css']  ,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('400ms ease-out', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [
        animate('400ms ease-out', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ], 
})  
 
//export class ValidationsComponent extends GenericEntryForm<any, any>{  
export class ValidationsComponent {  
  validationData: Array<any> = new Array<any>();
  local_data: any;
  title: string = '';
  constructor(public dialogRef: MatDialogRef<ValidationsComponent>,dialog: MatDialog,agenericRepository: GenericService<IUserModel>,
    @Inject(MAT_DIALOG_DATA) public data: any,router: Router) {
      //super(agenericRepository, router,dialog);
    this.local_data = { ...data };
  }
}
